/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet } from "../../funcs/schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$inboundSchema,
};

export const tool$schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-list-repositories-api-v1-sandbox-github-repositories-get",
    description: `List Repositories`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
